<pr-panel>
  <pr-panel-body>
    <div class="supports-table">
      @if (config.title || config.addLabel) {
        <div class="supports-table-head">
          @if (config.title) {
            <h3 class="supports-table-title man">{{ config.title }}</h3>
          }
          @if (rows.length) {
            <span class="supports-table-count">{{ rows.length }}</span>
          }
          @if (config.addLabel && rows.length) {
            <pr-button
              class="supports-table-add supports-add"
              size="sm"
              type="button"
              rightIcon="sp-plus"
              [iconViewBoxWidth]="24"
              [iconViewBoxHeight]="24"
              [label]="config.addLabel"
              (onClick)="addSupport.emit()"
            ></pr-button>
          }
        </div>
      }

      @if (rows.length) {
        <div class="supports-table-scroll">
          <table class="supports-table-grid">
            <thead>
              <tr>
                @for (column of columns; track column.label) {
                  <th [class.is-numeric]="column.type !== 'support'">
                    {{ column.label }}
                  </th>
                }
                @if (removable) {
                  <th class="is-action">Action</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row; let index = $index) {
                <tr [formGroup]="row">
                  @for (column of columns; track column.label) {
                    @if (column.type === 'support') {
                      <td class="is-support">
                        <span
                          class="supports-name"
                          [attr.title]="supportName(row, column)"
                        >
                          {{ supportName(row, column) }}
                        </span>
                        @if (supportDetail(row, column)) {
                          <span class="supports-isin">
                            {{ supportDetail(row, column) }}
                          </span>
                        }
                      </td>
                    } @else if (column.type === 'amount') {
                      <td class="is-numeric" [attr.data-label]="column.label">
                        {{
                          columnValue(row, column)
                            | number: column.digits || '1.2-2'
                        }}&nbsp;{{ column.unit }}
                      </td>
                    } @else {
                      <td class="is-numeric" [attr.data-label]="column.label">
                        <span
                          class="supports-field"
                          [class.is-empty-warning]="isEmptyWarning(row, column)"
                        >
                          @if (column.numeric) {
                            <input
                              eaNumericInput
                              [formControlName]="column.controlName"
                              [attr.aria-label]="column.ariaLabel"
                            />
                          } @else {
                            <input
                              type="number"
                              [formControlName]="column.controlName"
                              [attr.step]="column.step"
                              [attr.min]="column.min"
                              [attr.max]="columnMax(row, column)"
                              [attr.aria-label]="column.ariaLabel"
                            />
                          }
                          <span class="supports-field-unit">
                            {{ column.unit }}
                          </span>
                        </span>
                      </td>
                    }
                  }
                  @if (removable) {
                    <td class="is-action">
                      <pr-button-confirm
                        clazz="supports-table-remove"
                        display="danger"
                        variant="colored"
                        size="sm"
                        icon="delete_outline"
                        tooltip="Retirer le support"
                        title="Suppression"
                        [comment]="config.removeComment"
                        labelConfirm="Supprimer"
                        labelCancel="Annuler"
                        (onConfirm)="remove(row, index)"
                      >
                        Êtes-vous sûr(e) de vouloir supprimer le support :
                        <em>“{{ removeLabel(row) }}”</em>
                      </pr-button-confirm>
                    </td>
                  }
                </tr>
              }
            </tbody>
            @if (hasTotal) {
              <tfoot>
                <tr>
                  @for (
                    column of columns;
                    track column.label;
                    let first = $first
                  ) {
                    @if (first) {
                      <td class="is-total-label">
                        {{ config.totalLabel || 'Total' }}
                        @if (remainingPercent !== null) {
                          <span
                            class="supports-chip"
                            [class.is-complete]="isComplete"
                          >
                            @if (isComplete) {
                              Répartition complète
                            } @else {
                              reste {{ remainingPercent | number: '1.0-4' }} %
                              @if (hasRemainingAmount) {
                                , soit
                                {{
                                  config.remainingAmount | number: '1.2-2'
                                }}&nbsp;{{ config.remainingAmountUnit || '€' }}
                              }
                            }
                          </span>
                        }
                      </td>
                    } @else if (column.total) {
                      <td class="is-numeric" [attr.data-label]="column.label">
                        {{
                          columnTotal(column)
                            | number: column.digits || '1.2-2'
                        }}&nbsp;{{ column.unit }}
                      </td>
                    } @else {
                      <td></td>
                    }
                  }
                  @if (removable) {
                    <td></td>
                  }
                </tr>
              </tfoot>
            }
          </table>
        </div>
      } @else {
        <div class="supports-table-empty">
          <p class="man">
            {{
              config.emptyLabel || 'Aucun support sélectionné pour le moment.'
            }}
          </p>
          @if (config.addLabel) {
            <pr-button
              class="supports-add supports-add-lg"
              size="lg"
              type="button"
              rightIcon="sp-plus"
              [iconViewBoxWidth]="24"
              [iconViewBoxHeight]="24"
              [label]="config.addLabel"
              (onClick)="addSupport.emit()"
            ></pr-button>
          }
        </div>
      }
    </div>
  </pr-panel-body>
</pr-panel>
